import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { Field, ErrorMessage } from 'formik';

interface TextAreaInputProps {
    label: string;
    name: string;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({ label, name }) => {
    return (
        <Form.Group as={Col}>
            <Form.Label>{label}</Form.Label>
            <Field type="textarea" name={name} className="form-control" />
            <ErrorMessage name={name} component="div" className="text-danger" />
        </Form.Group>
    );
};

export default TextAreaInput;
